import React, { useEffect, useState } from "react";
import { getIcon } from "../../helpers/icons";
import { showToast } from "../../helpers/notify";
import { Button } from "../../components/Field/";
import Spinner from "../Spinner";
import Checkbox from "./Checkbox";
import AsyncGet from "../AsyncGet";
import Link from "../../components/Link";
import Title from "../../components/Title";
import Spacer from "../../components/Spacer";
import AsyncForm from "../../components/AsyncForm";

import style from "./style.module.css";


export default function MarketingPreferencesList(props) {
    const {
        closeDialog,
        userProfile = {},
    } = props;
    const [selected, setSelected] = useState([]);
    const [dataList, setDataList] = useState([]);

    useEffect(() => {
        if (dataList?.length > 0) {
            setSelected(dataList.filter(item => item.isSelected).map(item => item.id));
        }
    }, [dataList]);

    return (
        <div className={` ${style.feedback} ${style.popupArea}`}>
            <div className={style.popupWrap}>
                <div className={style.sectionHeader}>
                    <Link
                        className={`${style.dialogClose}`}
                        onClick={closeDialog}
                    >
                        <i className={getIcon("Arrow-left")}></i>
                    </Link>
                    <Title className="fontTeko" transform="uppercase" tag="h2">Marketing Preferences</Title>
                </div>
                <div className={style.sectionBody}>
                    <AsyncForm
                        id="update-interests"
                        url={`/account/update-interests`}
                        permissionText={false}
                        showToastOnSuccess={false}
                        hasGetAction={false}
                        onSave={({data}) => {
                            if(!data.error) {
                                closeDialog();
                                showToast("Your preferences updated");
                            }
                        }}
                        paramsData={{
                            email: userProfile.email,
                            interests: selected
                        }}
                        render={({ fetching, handleSubmit, onSubmit }) => {
                            return (
                                <>
                                    <Title tag="p">Select the content you’d like to receive:</Title>
                                    <Spacer size="32" />
                                    <AsyncGet
                                        key="get-interests"
                                        url={`/account/get-interests`}
                                        permissionText="Get Interests"
                                        loadOnMount={true}
                                        render={({ data }) => {
                                            setDataList(data.list);
                                            if (data && !data.error) {
                                                return (
                                                    <>
                                                        {
                                                            data.list.length > 0 && data.list.map((item, index) => {
                                                                return (
                                                                    <div key={`interest_${index}`}>
                                                                        <Checkbox
                                                                            label={item.name}
                                                                            id={`interests_${item.id}`}
                                                                            name={'interests'}
                                                                            checked={selected.includes(item.id)}
                                                                            onClick={() => {
                                                                                setSelected(prevSelected =>
                                                                                    prevSelected.includes(item.id)
                                                                                        ? prevSelected.filter(id => id !== item.id)
                                                                                        : [...prevSelected, item.id]
                                                                                );
                                                                            }}
                                                                        />
                                                                        <Spacer />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </>
                                                )
                                            }
                                            else {
                                                return (
                                                    <div className={style.loadingWrap}>
                                                        <Spinner />
                                                    </div>
                                                )
                                            }
                                        }}
                                    />
                                    <Spacer size="32" />
                                    <Button
                                        color="buttonPrimary"
                                        onClick={handleSubmit(onSubmit)}
                                        fetching={fetching}
                                        label="Submit"
                                    />
                                </>
                            )
                        }}
                    />
                </div>
            </div>
        </div>
    )
}